import React from 'react'
import Stack from '@mui/material/Stack'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'

import Link from '~/client/components/Link'
import Timestamp from '~/client/components/Timestamp'
import AppAccountLoginButton from '~/client/components/AppAccountLoginButton'

export default function AppAccountsList({
  appAccounts, loginButtonReturnTo
}){
  return <List spacing={1} sx={{mb: 2}}>
    {appAccounts.map(appAccount =>
      <ListItem key={appAccount.id} disablePadding>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{width: '100%'}}>
          <ListItemText
            primary={
              <Link to={`/accounts/${appAccount.app.host}/${appAccount.id}`}>
                {appAccount.nickname || appAccount.id}
              </Link>
            }
            secondary={<>Created: <Timestamp at={appAccount.createdAt}/></>}
          />
          <AppAccountLoginButton
            appAccountId={appAccount.id}
            returnTo={loginButtonReturnTo}
          />
        </Stack>
      </ListItem>
    )}
  </List>
}
